import i18n from '@/i18n';

const nameTab = {
    admin: i18n.t('managerForm.settingAdvanced.mailAdmin'),
    answer: i18n.t('managerForm.settingAdvanced.mailAnswer')
};
const TAB_EMAIL = [
    {
        id: 1,
        name: nameTab.admin,
        disabled: false
    },
    {
        id: 2,
        name: nameTab.answer,
        disabled: false
    }
];

const OPTION_MASK = [
    { id: 1, label: 'マスクする' },
    { id: 0, label: 'マスクしない' }
];

const OPTION_SENDING_CONDITIONS = [
    { id: 1, label: '送信する' },
    { id: 0, label: '送信しない' }
];

const OPTION_REPLY_ADDRESS = [{ id: 'default', label: 'アドレス入力' }];
const OPTION_MAIL_I = { id: 'default_mail_registed_i', label: '登録済メールアドレス' };
const OPTION_NOT_SELECTED = [{ id: 'not_selected', value: '未選択', is_not_selected: true }];

const subjectText = `[Paldia Form] 登録データ送信 [(<<パラメータ:form_id>>) <<パラメータ:フォーム名>>:<<パラメータ:answer_id>>]`;
const mainText = `━┫登録データ送信┣━━━━━━━━━━━━━━━━━━━━━━━━━━<br>
フォームID：<<パラメータ:form_id>> フォーム名：<<パラメータ:フォーム名>> 回答ID：<<パラメータ:answer_id>><br>
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━<br>
＊等幅フォントでご覧になることをお奨めします。<br>
登録日時     : <<パラメータ:回答日時>><br>
IPアドレス   : <<パラメータ:IPアドレス>><br>
ブラウザ情報 : <<パラメータ:ブラウザ情報>><br>
リンク元     : <<パラメータ:リンク元>><br>
＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br>
<<フォーム:全回答データ>><br>
＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br>
`;
const subjectTextAnswer = `受付完了連絡`;
const mainTextAnswer = `<div>ありがとうございました。</div>`;
const OPTION_SEND_EMAIL = () => {
    return [
        { id: 1, label: '送信する' },
        { id: 2, label: '条件を指定して送信する' },
        { id: 3, label: '送信しない' }
    ];
};

const OPTION_SUBJECT_DEFAULT = () => [
    {
        id: 'All responses',
        label: 'フォーム:全回答データ'
    },
    {
        id: 'Form Id',
        label: 'パラメータ:form_id'
    },
    {
        id: 'Answer Id',
        label: 'パラメータ:answer_id'
    },
    {
        id: 'Form Name',
        label: 'パラメータ:フォーム名'
    },
    {
        id: 'Answer date and time',
        label: 'パラメータ:回答日時'
    },
    {
        id: 'IP address',
        label: 'パラメータ:IPアドレス'
    },
    {
        id: 'Browser information',
        label: 'パラメータ:ブラウザ情報'
    },
    {
        id: 'Link source',
        label: 'パラメータ:リンク元'
    }
];

const selectDefaultSendmail = () => {
    return {
        id: 'default_no_choice',
        label: '差込タグ'
    };
};
const initFieldAdmin = (dataAdmin = null) => {
    return {
        option_send_email: dataAdmin?.option_send_email ?? 3,
        to_address: dataAdmin?.to_address?.toString() ?? '',
        bcc_address: dataAdmin?.bcc_address?.toString() ?? '',
        choice_reply_address: dataAdmin?.choice_reply_address?.toString() ?? OPTION_REPLY_ADDRESS[0],
        email_reply_address: dataAdmin?.email_reply_address ?? '',
        subject: dataAdmin?.subject ?? subjectText,
        main_text: dataAdmin?.main_text ?? mainText,
        masking_personal_information_fields: dataAdmin?.masking_personal_information_fields ?? 1,
        block_id: dataAdmin?.block_id ?? null,
        email_settings_for_each_option: dataAdmin?.email_settings_for_each_option ?? [],
        configEachField: (dataConfigAdmin = null) => {
            return {
                configFieldFromAddress: {
                    trackBy: 'id',
                    label: 'label_mail',
                    error: false,
                    isRemove: false,
                    multiple: false,
                    errorField: i18n.t('managerForm.settingAdvanced.fromAddress'),
                    valueSync: dataConfigAdmin?.from_address ?? null,
                    typesValidate: ['required']
                },
                configFieldToAddress: {
                    autocomplete: 'new-email',
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.toAddress'),
                    errorCustomMess: '',
                    placeholder: 'user@example.com',
                    valueSync: dataConfigAdmin?.to_address?.toString() ?? '',
                    length: 1000,
                    typesValidate: ['required', 'maxCustom']
                },
                configFieldBccAddress: {
                    autocomplete: 'new-email',
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.bcc'),
                    errorCustomMess: '',
                    placeholder: 'user@example.com',
                    valueSync: dataConfigAdmin?.bcc_address?.toString() ?? '',
                    length: 1000,
                    typesValidate: ['maxCustom']
                },
                configFieldSubject: {
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.subject'),
                    errorCustomMess: '',
                    valueSync: dataConfigAdmin?.subject ?? subjectText,
                    length: 150,
                    typesValidate: ['required', 'maxCustom']
                },
                configFieldMainText: {
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.mainText'),
                    errorCustomMess: '',
                    classCustom: 'pt-5',
                    valueSync: dataConfigAdmin?.main_text ?? mainText,
                    typesValidate: ['requiredCustomMsg']
                },
                configFieldSelectMailSendingConditions: {
                    trackBy: 'id',
                    label: 'block_name',
                    errorField: i18n.t('managerForm.settingAdvanced.conditionSendEmail'),
                    valueSync: dataConfigAdmin?.block_id ?? null,
                    error: false,
                    isRemove: true,
                    typesValidate: ['requiredSelect']
                },
                configFieldSelectChoiceSendingMail: {
                    trackBy: 'id',
                    label: 'label',
                    error: false,
                    isRemove: true,
                    classCustom: 'select__block--mail--form',
                    typesValidate: []
                },
                configFieldReplyAddress: {
                    trackBy: 'id',
                    label: 'email_address',
                    error: false,
                    isRemove: false,
                    multiple: false,
                    errorField: i18n.t('managerForm.settingAdvanced.toAddress'),
                    valueSync: dataConfigAdmin?.email_reply_address ?? null,
                    typesValidate: []
                }
            };
        }
    };
};

const initSettingEmailOption = (dataEachOptionAdmin = null) => {
    return {
        option_id: dataEachOptionAdmin?.option_id ?? null,
        send_setting: dataEachOptionAdmin?.send_setting ?? 0,
        to_address: dataEachOptionAdmin?.to_address?.toString() ?? null,
        is_custom_value: dataEachOptionAdmin?.is_custom_value ?? false,
        bcc_address: dataEachOptionAdmin?.bcc_address?.toString() ?? '',
        subject: dataEachOptionAdmin?.subject ?? subjectText,
        main_text: dataEachOptionAdmin?.main_text ?? mainText,
        configEachField: (dataConfigEachAdmin = null) => {
            return {
                configFieldToAddress: {
                    autocomplete: 'new-email',
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.toAddress'),
                    errorCustomMess: '',
                    placeholder: 'user@example.com',
                    valueSync: dataConfigEachAdmin?.to_address?.toString() ?? '',
                    length: 1000,
                    typesValidate: ['required', 'maxCustom']
                },
                configFieldBccAddress: {
                    autocomplete: 'new-email',
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.bcc'),
                    errorCustomMess: '',
                    placeholder: 'user@example.com',
                    valueSync: dataConfigEachAdmin?.bcc_address?.toString() ?? '',
                    length: 1000,
                    typesValidate: ['maxCustom']
                },
                configFieldSubject: {
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.subject'),
                    errorCustomMess: '',
                    valueSync: dataConfigEachAdmin?.subject ?? subjectText,
                    length: 150,
                    typesValidate: ['required', 'maxCustom']
                },
                configFieldMainText: {
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.mainText'),
                    errorCustomMess: '',
                    classCustom: 'pt-5',
                    valueSync: dataConfigEachAdmin?.main_text ?? mainText,
                    typesValidate: ['requiredCustomMsg']
                },
                configFieldSelectChoiceSendingMail: {
                    trackBy: 'id',
                    label: 'label',
                    error: false,
                    isRemove: true,
                    classCustom: 'select__block--mail--form',
                    typesValidate: []
                }
            };
        }
    };
};

const initFieldAnswer = (dataClient = null) => {
    return {
        option_send_email: dataClient?.option_send_email ?? 3,
        to_address: dataClient?.to_address ?? [],
        choice_reply_address: dataClient?.choice_reply_address ?? [],
        bcc_address: dataClient?.bcc_address?.toString() ?? '',
        subject: dataClient?.subject ?? subjectTextAnswer,
        main_text: dataClient?.main_text ?? mainTextAnswer,
        block_id: dataClient?.block_id ?? null,
        email_settings_for_each_option: dataClient?.email_settings_for_each_option ?? [],

        configEachField: (dataConfigClient = null) => {
            return {
                configFieldFromAddress: {
                    trackBy: 'id',
                    label: 'label_mail',
                    error: false,
                    isRemove: false,
                    multiple: false,
                    errorField: i18n.t('managerForm.settingAdvanced.fromAddress'),
                    valueSync: dataConfigClient?.from_address ?? null,
                    typesValidate: ['required']
                },
                configFieldBccAddress: {
                    autocomplete: 'new-email',
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.bcc'),
                    errorCustomMess: '',
                    placeholder: 'user@example.com',
                    valueSync: dataConfigClient?.bcc_address?.toString() ?? '',
                    length: 1000,
                    typesValidate: ['maxCustom']
                },
                configFieldReplyAddress: {
                    trackBy: 'id',
                    label: 'label',
                    error: false,
                    isRemove: true,
                    multiple: true,
                    errorField: i18n.t('managerForm.settingAdvanced.toAddress'),
                    valueSync: dataConfigClient?.choice_reply_address ?? null,
                    typesValidate: ['requiredSelect']
                },
                configFieldSubject: {
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.subject'),
                    errorCustomMess: '',
                    valueSync: dataConfigClient?.subject ?? subjectTextAnswer,
                    length: 150,
                    typesValidate: ['required', 'maxCustom']
                },
                configFieldMainText: {
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.mainText'),
                    errorCustomMess: '',
                    valueSync: dataConfigClient?.main_text ?? mainTextAnswer,
                    classCustom: 'pt-5',
                    typesValidate: ['requiredCustomMsg']
                },
                configFieldSelectMailSendingConditions: {
                    trackBy: 'id',
                    label: 'block_name',
                    errorField: i18n.t('managerForm.settingAdvanced.conditionSendEmail'),
                    valueSync: dataConfigClient?.block_id ?? null,
                    error: false,
                    isRemove: true,
                    typesValidate: ['requiredSelect']
                },
                configFieldSelectChoiceSendingMail: {
                    trackBy: 'id',
                    label: 'label',
                    error: false,
                    isRemove: true,
                    classCustom: 'select__block--mail--form',
                    typesValidate: []
                }
            };
        }
    };
};

const initSettingEmailOptionAnswer = (dataAnswerEachOption = null) => {
    return {
        send_setting: dataAnswerEachOption?.send_setting ?? 0,
        option_id: dataAnswerEachOption?.option_id ?? null,
        choice_reply_address: dataAnswerEachOption?.choice_reply_address ?? [],
        to_address: dataAnswerEachOption?.to_address ?? [],
        is_custom_value: dataAnswerEachOption?.is_custom_value ?? false,
        bcc_address: dataAnswerEachOption?.bcc_address?.toString() ?? '',
        from_address: dataAnswerEachOption?.from_address ?? '',
        subject: dataAnswerEachOption?.subject ?? subjectTextAnswer,
        main_text: dataAnswerEachOption?.main_text ?? mainTextAnswer,
        configEachField: (dataAnswerConfigEachOption = null) => {
            return {
                configFieldReplyAddress: {
                    trackBy: 'id',
                    label: 'label',
                    error: false,
                    isRemove: true,
                    multiple: true,
                    errorField: i18n.t('managerForm.settingAdvanced.toAddress'),
                    valueSync: dataAnswerConfigEachOption?.to_address ?? [],
                    typesValidate: ['requiredSelect']
                },
                configFieldFromAddress: {
                    trackBy: 'id',
                    label: 'label_mail',
                    error: false,
                    isRemove: false,
                    multiple: false,
                    errorField: i18n.t('managerForm.settingAdvanced.fromAddress'),
                    valueSync: dataAnswerConfigEachOption?.from_address ?? null,
                    typesValidate: ['required']
                },
                configFieldBccAddress: {
                    autocomplete: 'new-email',
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.bcc'),
                    errorCustomMess: '',
                    placeholder: 'user@example.com',
                    valueSync: dataAnswerConfigEachOption?.bcc_address?.toString() ?? '',
                    length: 1000,
                    typesValidate: ['maxCustom']
                },
                configFieldSubject: {
                    isNumber: false,
                    isMaxLength: false,
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.subject'),
                    errorCustomMess: '',
                    valueSync: dataAnswerConfigEachOption?.subject ?? subjectTextAnswer,
                    length: 150,
                    typesValidate: ['required', 'maxCustom']
                },
                configFieldMainText: {
                    error: false,
                    errorField: i18n.t('managerForm.settingAdvanced.mainText'),
                    errorCustomMess: '',
                    classCustom: 'pt-5',
                    valueSync: dataAnswerConfigEachOption?.main_text ?? mainTextAnswer,
                    typesValidate: ['requiredCustomMsg']
                },
                configFieldSelectChoiceSendingMail: {
                    trackBy: 'id',
                    label: 'label',
                    error: false,
                    isRemove: true,
                    classCustom: 'select__block--mail--form',
                    typesValidate: []
                }
            };
        }
    };
};

export {
    OPTION_MASK,
    OPTION_SENDING_CONDITIONS,
    OPTION_REPLY_ADDRESS,
    OPTION_MAIL_I,
    TAB_EMAIL,
    OPTION_NOT_SELECTED,
    nameTab,
    OPTION_SEND_EMAIL,
    OPTION_SUBJECT_DEFAULT,
    selectDefaultSendmail,
    initFieldAdmin,
    initFieldAnswer,
    initSettingEmailOption,
    initSettingEmailOptionAnswer
};
